class VariantSwatch extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    // Listen for variant changes
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const target = this.getInputForEventTarget(event.target);

    const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
    this.pendingRequestUrl = productUrl;

    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, this.selectedOptionValues),
      targetId: target.id
    });
  }

  async renderProductInfo({ requestUrl, targetId }) {
    this.abortController?.abort();
    this.abortController = new AbortController();
  
    try {
      const response = await fetch(requestUrl, { signal: this.abortController.signal })
      const responseText = await response.text()
      this.pendingRequestUrl = null;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      this.updateOptionValues(html)
    } catch(error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted by user");
      } else {
        console.error(error);
      }
    }
  }

  updateOptionValues(html) {
    const inputs = this.querySelectorAll("input[type='radio']");
    const newInputs = html.querySelectorAll("input[type='radio']");

    inputs.forEach((input) => {
      const newInput = [...newInputs].find((newInput) => newInput.id === input.id);

      if (newInput) {
        input.classList = newInput.classList;
        if (newInput.closest(".radio__button")) {
          input.closest(".radio__button").classList = newInput.closest(".radio__button").classList;
        }
      }
    });
  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = [];

    params.push(`section_id=${this.sectionId}`);

    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(",")}`);
    }

    return `${url}?${params.join("&")}`;
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(
      ({ dataset }) => dataset.optionValueId,
    );
  }
}

customElements.define('variant-swatch', VariantSwatch); 